import { useLayoutEffect } from 'react';
/**
 * Grows a comment composer's textarea to fit its text, up to `maxHeight` (past it the box scrolls), and refits when the
 * box's WIDTH changes as well as when the text does: a narrower window (a phone turned upright, a resized browser or
 * sidebar) wraps a typed draft with no input event, and the height kept from the wider box clipped the wrapped lines
 * (2026-10-27 mini run, dashboard composer at 390 and 320px). Height-only changes are this hook's own writes and are
 * ignored. Used by the dashboard CommentComposer and the Team Review and extension MentionInput.
 */
export function useTextareaAutoHeight(ref, value, maxHeight = Infinity) {
    useLayoutEffect(() => {
        const textarea = ref.current;
        if (!textarea)
            return;
        const fit = () => { textarea.style.height = 'auto'; textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`; };
        fit();
        if (typeof ResizeObserver === 'undefined')
            return;
        let width = textarea.clientWidth;
        const observer = new ResizeObserver(() => { if (textarea.clientWidth !== width) {
            width = textarea.clientWidth;
            fit();
        } });
        observer.observe(textarea);
        return () => observer.disconnect();
    }, [ref, value, maxHeight]);
}
//# sourceMappingURL=useTextareaAutoHeight.js.map